import type { MeetupManagementListItemModel } from 'src/lib/services/api/organizations/meetups/meetup-management.model';

export function getWonderMeetupOccurrenceKey(
	meetup: MeetupManagementListItemModel,
): string {
	if (meetup.id != null) {
		return `id:${meetup.id}`;
	}

	return [
		'fallback',
		meetup.scheduled_meetup_id ?? 'unscheduled',
		meetup.start_date?.getTime() ?? 'unknown-start',
		meetup.end_date?.getTime() ?? 'unknown-end',
		meetup.link?.trim() ?? '',
	].join(':');
}
